const QueryData = {
  STATION: { key: "stations", url: "path/station?pageLength=10" },
  PATH: { key: "path", url: "path?" },
  SERVICE: { key: "services", url: "trip-plan/service-plan?pageLength=10" },
  SURVEY: { key: "survey", url: "survey?pageLength=1000" },
};

export default QueryData;
